/* eslint-disable no-console */
import { fetchJSON } from '@bonnet/next/fetch';

export default (query) => fetchJSON('/collections/service/requestEmailUsService', { query });
